import React from 'react';
import { ButtonPrimary } from '../../../../ui/atoms/Button';

// Standardized AddToCart button used in PDP's and floating cart
export const AddToCartButton = ({ className, ...props }: React.ComponentProps<typeof ButtonPrimary>) => (
  <ButtonPrimary className={`w-full ${className || ''}`} {...props} />
);
